import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import { UI_MODE } from 'framework-listing-lib/constants/uiMode';
import { useAppSettingsUIModes } from 'framework-listing-lib/internal/frameworkAppSettings/hooks/useFrameworkAppSettings';
import { useUiModeProps } from 'framework-listing-lib/internal/providers/ListingProvider';
export default function useUIMode() {
  "use memo";

  const $ = _c(4);
  const uiModes = useUIModes();
  const uiModeProps = useUiModeProps();
  let t0;
  bb0: {
    if (!uiModeProps) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          currentUIMode: UI_MODE.LIST
        };
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    const currentUIModeFromProps = uiModeProps.currentUIMode ? UI_MODE[uiModeProps.currentUIMode] : undefined;
    const currentUIMode = currentUIModeFromProps && uiModes.includes(currentUIModeFromProps) ? currentUIModeFromProps : currentUIModeFromProps || UI_MODE.LIST;
    let t1;
    if ($[1] !== currentUIMode || $[2] !== uiModeProps.onChangeUIMode) {
      t1 = {
        currentUIMode,
        onChangeUIMode: uiModeProps.onChangeUIMode
      };
      $[1] = currentUIMode;
      $[2] = uiModeProps.onChangeUIMode;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    t0 = t1;
  }
  return t0;
}
export function useOnChangeUIMode() {
  "use memo";

  const $ = _c(4);
  const currentUIMode = useCurrentUIMode();
  const uiModeProps = useUIMode();
  const uiModes = useUIModes();
  let t0;
  if ($[0] !== currentUIMode || $[1] !== uiModeProps || $[2] !== uiModes) {
    t0 = newUIMode => {
      if (!uiModeProps.onChangeUIMode) {
        return;
      }
      if (currentUIMode === newUIMode) {
        return;
      }
      uiModeProps.onChangeUIMode(newUIMode, {
        previousUIMode: currentUIMode,
        uiModes
      });
    };
    $[0] = currentUIMode;
    $[1] = uiModeProps;
    $[2] = uiModes;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
export function useUIModes() {
  "use memo";

  return useAppSettingsUIModes();
}
export function useCurrentUIMode() {
  "use memo";

  const uiModeProps = useUIMode();
  return uiModeProps.currentUIMode;
}
export function useIsFoldersMode() {
  "use memo";

  const currentUIMode = useCurrentUIMode();
  return currentUIMode === UI_MODE.FOLDERS;
}
export function useIsGalleryMode() {
  "use memo";

  const currentUIMode = useCurrentUIMode();
  return currentUIMode === UI_MODE.GALLERY;
}
export function useIsCalendarMode() {
  "use memo";

  const currentUIMode = useCurrentUIMode();
  return currentUIMode === UI_MODE.CALENDAR;
}
export function useIsListMode() {
  "use memo";

  const currentUIMode = useCurrentUIMode();
  return currentUIMode === UI_MODE.LIST;
}
export function useHasFoldersMode() {
  "use memo";

  const $ = _c(2);
  const uiModes = useUIModes();
  let t0;
  if ($[0] !== uiModes) {
    t0 = uiModes.includes(UI_MODE.FOLDERS);
    $[0] = uiModes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}